/**
 * CheTuo Web — SaaS admin layout with sidebar navigation.
 */

import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AppShell } from './AppShell';

const ADMIN_NAV_GROUPS = [
  {
    title: '运营',
    items: [
      { path: '/admin/dashboard', label: '平台总览' },
      { path: '/admin/shops', label: '租户门店' },
      { path: '/admin/subscriptions', label: '套餐订阅' },
      { path: '/admin/payment-orders', label: '支付订单' },
      { path: '/admin/ai-quota', label: 'AI 工具额度' },
    ],
  },
  {
    title: '管理',
    items: [
      { path: '/admin/admin-users', label: '平台管理员' },
      { path: '/admin/settings', label: '平台配置' },
      { path: '/admin/audit-logs', label: '操作日志' },
    ],
  },
  {
    items: [{ path: '/admin/plan-orders', label: '套餐订单' }],
  },
];

export function AdminLayout(): React.JSX.Element {
  const navigate = useNavigate();
  const { user, isLoggedIn, logout } = useAuth();

  if (!isLoggedIn || !user?.isSuperAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  return (
    <AppShell
      title="车妥"
      subtitle="SaaS 管理后台"
      headerTitle="平台管理"
      headerSubtitle={user?.phone}
      groups={ADMIN_NAV_GROUPS}
      onLogout={handleLogout}
      footer={
        <div className="px-3">
          <p className="truncate text-xs text-gray-500">{user?.displayName ?? user?.phone}</p>
          <p className="text-xs text-blue-600">超级管理员</p>
        </div>
      }
    />
  );
}
